import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import "./MobileTabSelector.scss";

export type MobileTabSelectorValue = string | number;

export interface MobileTabSelectorOption {
    id: MobileTabSelectorValue;
    label: string;
    disabled?: boolean;
}

interface MobileTabSelectorProps {
    options: MobileTabSelectorOption[];
    value: MobileTabSelectorValue;
    onChange: (id: MobileTabSelectorValue) => void;
    className?: string;
    placeholder?: string;
    ariaLabel?: string;
    id?: string;
}

export default function MobileTabSelector({
    options,
    value,
    onChange,
    className = "",
    placeholder = "Seleccionar",
    ariaLabel = "Seleccionar tab",
    id,
}: Readonly<MobileTabSelectorProps>) {
    const rootClassName = `mobile-tab-selector ${className}`.trim();

    function handleChange(event: DropdownChangeEvent) {
        const nextId = event.value as MobileTabSelectorValue | undefined;
        const nextOption = options.find((option) => option.id === nextId);
        if (!nextOption || nextOption.disabled) return;
        onChange(nextOption.id);
    }

    return (
        <div className={rootClassName}>
            <Dropdown
                id={id}
                className="w-full"
                value={value}
                options={options}
                optionLabel="label"
                optionValue="id"
                optionDisabled="disabled"
                editable={false}
                placeholder={placeholder}
                aria-label={ariaLabel}
                onChange={handleChange}
            />
        </div>
    );
}
